import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import {fetchKanbanBoards, performAction} from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { ORBModal } from '../../../ORB/components/ORBModal'; 
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import styles from './ADM_NL_IDW.module.css';

import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { getRemarkType } from '../helpers/getRemarkType';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { selectUserId, selectWork,selectWorks } from '../../../Api/selectors';

const Container = styled.div``;


const TASK_REMARK_TYPE = 'Verkoop_vrijwaren';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const STATE = {
  approve: false,
  regplate_code: '',
  showModal: false,
};

/* eslint-disable react/prefer-stateless-function */
class ADM_OUT_5_sales_releaseComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset = () => {
    this.setState({ ...STATE });
    this.props.fetch();
  };

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.state.regplate_code);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <Label count={vehicle?.verkoopvrijwarendoorlooptijd_counter} ranges={ranges}>
            {vehicle?.verkoopvrijwarendoorlooptijd_counter}
            
          </Label>
          <CellButtons>
          {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton onClick={this.setStateFn({ showModal: true })}                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        { !!this.state.showModal && <ORBModal item={vehicle} onClose={this.reset}/>}
      </Cell>
    );
  }
}

      
      
    

ADM_OUT_5_sales_releaseComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),

  });

  

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(regplate_code) {
      if (!ownProps.cell.vehicle.id) throw 'no vehicle id';
      dispatch(performAction(ownProps.action.id, ownProps.cell.vehicle.id, { regplate_code }));
    },
    fetch: () => {
      dispatch(fetchKanbanBoards());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);



export const ADM_OUT_5_sales_release = compose(
  withConnect,
  withRouter,
)(ADM_OUT_5_sales_releaseComp);
